// AGENTS
export const FETCH_AGENTS = 'FETCH_AGENTS'
export const FETCH_AGENTS_SUCCESS = 'FETCH_AGENTS_SUCCESS'
export const FETCH_AGENTS_FAILURE = 'FETCH_AGENTS_FAILURE'
export const FETCH_AGENT = 'FETCH_AGENT'
export const FETCH_AGENT_SUCCESS = 'FETCH_AGENT_SUCCESS'
export const FETCH_AGENT_FAILURE = 'FETCH_AGENT_FAILURE'
export const CLEAR_SELECTED_AGENT = 'CLEAR_SELECTED_AGENT'

// RESOURCES
export const FETCH_RESOURCES = 'FETCHING_RESOURCES'
export const FETCH_RESOURCES_SUCCESS = 'FETCHING_RESOURCES_SUCCESS'
export const FETCH_RESOURCES_FAILURE = 'FETCHING_RESOURCES_FAILURE'

// SINGLE RESOURCE
export const FETCH_RESOURCE = 'FETCHING_RESOURCE'
export const FETCH_RESOURCE_SUCCESS = 'FETCHING_RESOURCE_SUCCESS'
export const FETCH_RESOURCE_FAILURE = 'FETCHING_RESOURCE_FAILURE'
export const CLEAR_RESOURCE = 'CLEAR RESOURCE'

// OBSERVATIONS
export const FETCH_OBSERVATIONS = 'FETCH_OBSERVATIONS'
export const FETCH_OBSERVATIONS_SUCCESS = 'FETCH_OBSERVATIONS_SUCCESS'
export const FETCH_OBSERVATIONS_FAILURE = 'FETCH_OBSERVATIONS_FAILURE'
export const OBSERVATION_SELECTED = 'OBSERVATION_SELECTED'
export const OBSERVATION_DESELECTED = 'OBSERVATION_DESELECTED'
export const CLEAR_OBSERVATIONS = 'CLEAR_OBSERVATIONS'

export const FETCH_AGENTS_BY_OBSERVATIONS = 'FETCH_AGENTS_BY_OBSERVATIONS'
export const FETCH_AGENTS_BY_OBSERVATIONS_SUCCESS = 'FETCH_AGENTS_BY_OBSERVATIONS_SUCCESS'
export const FETCH_AGENTS_BY_OBSERVATIONS_FAILURE = 'FETCH_AGENTS_BY_OBSERVATIONS_FAILURE'

// GENERAL
export const SET_ROLE = 'SET_ROLE'
